import { render, staticRenderFns } from "./swaps.vue?vue&type=template&id=6aeddf88"
import script from "./swaps.vue?vue&type=script&lang=js"
export * from "./swaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports